<script>
  import { fade } from 'svelte/transition';

  const features = [
    {
      icon: 'ar_on_you',
      title: 'Find',
      description:
        'Reach the right decision-makers faster. Set your ideal buyer criteria and let AddMeetings match you with professionals whose needs align with your solution — no more cold guessing.',
    },
    {
      icon: 'podium',
      title: 'Pitch',
      description: 'Deliver personalized, context-aware pitches. Send text-based pitches that land directly with relevant buyers already open to your type of offering  cutting through the noise of traditional outreach.',
    },
    {
      icon: 'handshake',
      title: 'Meet',
      description: 'Book meetings that actually matter. Connect only with interested, qualified buyers who’ve already been filtered by AddMeetings’ intent-based AI, saving you time and maximizing conversion potential.',
    },
  ];
</script>

<section class="py-16">
  <div class="container mx-auto px-4 md:px-16 xl:px-24">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
      {#each features as feature, i}
        <div class="feature flex flex-col items-start" in:fade={{ duration: 300, delay: 150 * i }}>
          <div class="mb-1">
            <span
              class="material-symbols-rounded text-[#536aff]"
              style="font-size: 40px; font-variation-settings: 'FILL' 0, 'wght' 300;"
            >
              {feature.icon}
            </span>
          </div>
          <h3 class="text-2xl !font-bold text-am-black mb-3">{feature.title}</h3>
          <p class="text-am-black-75 font-semibold max-w-sm">{feature.description}</p>
        </div>
      {/each}
    </div>
  </div>
</section>

<style>
  /* Add smooth transitions */
  div.feature {
    transition: transform 0.2s ease;
  }

  div.feature:hover {
    transform: translateY(-4px);
  }
</style>
